import { render, staticRenderFns } from "./DetailsSession.vue?vue&type=template&id=312bea1b&"
import script from "./DetailsSession.vue?vue&type=script&lang=js&"
export * from "./DetailsSession.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports